// Phase 17A — WhatsApp deep-link helper. No API integration.
// Builds a `https://wa.me/<phone>?text=<message>` URL suitable for a plain
// anchor tag. The admin manually clicks Send inside WhatsApp / WhatsApp Web.
//
// Behaviour:
//   - Strips every non-digit character from the input phone.
//   - If the result is a 10-digit Indian mobile without country code, prefix "91".
//   - If the result already starts with a country code (>10 digits, up to 15),
//     it is passed through unchanged.
//   - If fewer than 10 usable digits remain, returns `null` so callers can
//     hide/disable the WhatsApp button — we never generate a broken link.
//
// The database `contact_phone` field is NEVER mutated.

export function normalizePhoneForWhatsapp(raw) {
  if (!raw || typeof raw !== "string") return null;
  const digits = raw.replace(/\D+/g, "");
  if (digits.length < 10) return null;
  if (digits.length === 10) return `91${digits}`;
  if (digits.length > 15) return null;
  return digits;
}

export function buildWhatsappUrl(phone, message) {
  const normalized = normalizePhoneForWhatsapp(phone);
  if (!normalized) return null;
  const text = encodeURIComponent(message || "");
  return `https://wa.me/${normalized}?text=${text}`;
}

// Convenience: composes the standard Phase-17A payment-request message.
export function buildPaymentRequestMessage({
  contactName, companyName, planName, amount,
}) {
  const greeting = contactName ? `Hi ${contactName},` : "Hi,";
  const amountStr = (typeof amount === "number" && !Number.isNaN(amount))
    ? `\u20B9${amount.toLocaleString("en-IN")}` : "\u20B9—";
  return [
    greeting,
    "",
    `Your Barter India registration${companyName ? ` for ${companyName}` : ""} has been approved.`,
    `Selected Plan: ${planName || "—"}`,
    `Subscription Amount: ${amountStr}`,
    "",
    "Please make the subscription payment using the payment details shared with you.",
    "Once payment is received and confirmed, your Barter India account will be activated and the applicable Trade Credits will be allocated.",
    "",
    "Thank you,",
    "Barter India",
  ].join("\n");
}
